import React from "react";
import Modal from "react-modal";
import {
  AbasContainer,
  BotaoAba,
  BotaoCard,
  Card,
  CardBody,
  CardHeader,
  LogoCard,
  Separador,
  TextoBody,
  TextoBotao,
  TextoContainer,
  TituloCard,
  TituloContainer,
  ModalContainer,
  ModalBody,
  LinkManual,
  StyledModal,
  TituloModal,
  SubtituloModal,
  ConteudoModal,
  ModalHeader,
  CloseModal,
} from "./style";
import { useState } from "react";
import {
  MANUAL,
  ORIENTACOES_GERAIS,
  PRIMEIRO_ACESSO,
} from "../../../../utils/Constants";
import CloseModalIcon from "../../../../assets/icons/CloseModalIcon";

const CardSistemas = ({ sistema }) => {
  const [abaSistema] = useState(1);
  const [modalAberta, setModalAberta] = useState(false);

  const basePath = `${process.env.PUBLIC_URL}/images/`;

  const getLogoBySystemName = (systemName) => {
    switch (systemName) {
      case "SISLAM - Sistema de Licenciamento Ambiental - IPAAM":
        return `${basePath}LogoSISLAM.png`;
      case "Sistema Entrada Única":
        return `${basePath}LogoEntradaUnica.png`;
      case "Sistema Carteira de Pesca":
        return `${basePath}LogoCarteiraDePesca.png`;
      case "SID - AM":
        return `${basePath}sid.jpg`;
      case "Configurador":
        return `${basePath}logo_configurador_licenciamento.png`;
      default:
        return `${basePath}LogoPainelDeInformacoes.png`;
    }
  };

  const abrirModal = () => {
    setModalAberta(true);
  };

  return (
    <>
      <Card>
        <CardHeader>
          <LogoCard src={getLogoBySystemName(sistema.nome)} alt="Logo" />
          <TituloContainer>
            <TituloCard>{sistema.nome}</TituloCard>
          </TituloContainer>
        </CardHeader>
        <Separador />
        <CardBody>
          <AbasContainer>
            <BotaoAba active={abaSistema === 1}>Sobre o sistema</BotaoAba>
            {(sistema.orientacoes ||
              sistema.primeiroAcesso ||
              sistema.manual) && (
              <BotaoAba onClick={() => abrirModal()}>Orientações</BotaoAba>
            )}
          </AbasContainer>
          <TextoContainer>
            <TextoBody>{sistema.descricao}</TextoBody>
          </TextoContainer>
          <BotaoCard
            onClick={() => window.open(sistema.link, "_blank", "noreferrer")}
          >
            <TextoBotao>Acessar</TextoBotao>
          </BotaoCard>
        </CardBody>
      </Card>
      {(sistema.orientacoes || sistema.primeiroAcesso || sistema.manual) && (
        <Modal isOpen={modalAberta} style={StyledModal}>
          <ModalContainer>
            <ModalHeader>
              <TituloModal>{sistema.nome}</TituloModal>
              <CloseModal onClick={() => setModalAberta(false)}>
                <CloseModalIcon />
              </CloseModal>
            </ModalHeader>
            <ModalBody>
              {sistema.orientacoes && (<>
                <SubtituloModal>{ORIENTACOES_GERAIS}</SubtituloModal>
                <ConteudoModal>{sistema.orientacoes}</ConteudoModal>
                </>
              )}

              {sistema.orientacoes && (<>
                <SubtituloModal>{PRIMEIRO_ACESSO}</SubtituloModal>
                <ConteudoModal
                  dangerouslySetInnerHTML={{ __html: sistema.primeiroAcesso }}
                />
                </>
              )}

              {sistema.manual && (
                <>
                  <SubtituloModal>{MANUAL}</SubtituloModal>
                  <ConteudoModal
                    onClick={() =>
                      window.open(sistema.manual, "_blank", "noreferrer")
                    }
                  >
                    <LinkManual>{sistema.nome} (Baixar Manual)</LinkManual>
                  </ConteudoModal>
                </>
              )}
            </ModalBody>
          </ModalContainer>
        </Modal>
      )}
    </>
  );
};

export default CardSistemas;
